<template>
  <div v-if="content" :class="{ 'shadow-sm': isShowLessButtonVisible }">
    <div
      ref="textContainerRef"
      class="relative whitespace-pre-wrap rounded-t-md border border-divider p-4"
      :class="[
        isLoadMoreButtonVisible ? 'max-h-30 overflow-hidden pb-0' : 'pb-4',
        { 'rounded-b-md shadow-sm': !isShowLessButtonVisible }
      ]"
    >
      <div
        class="break-word text-headline"
        data-cy="email-content"
        v-html="content"
      />
      <div
        v-if="isLoadMoreButtonVisible"
        class="absolute bottom-0 left-0 flex w-full cursor-pointer items-center justify-center space-x-2 bg-show-more-white-gradient pb-2 pt-4 text-primary"
        @click="handleShouldLoadMoreButtonClick"
      >
        <icon-base
          :icon="IconAdd"
          width="20"
          height="20"
          class="scale-75 transform"
        />
        <span>{{ $t("COMMON.SHOW_MORE") }}</span>
        <icon-base
          :icon="IconAdd"
          width="20"
          height="20"
          class="scale-75 transform"
        />
      </div>
    </div>
    <div
      v-if="isShowLessButtonVisible"
      class="flex w-full cursor-pointer items-center justify-center space-x-2 rounded-b-md border border-t-0 p-2 text-primary"
      @click="handleShouldShowLoadLessButtonClick"
    >
      <icon-base
        :icon="IconAdd"
        width="20"
        height="20"
        class="scale-75 transform"
      />
      <span>{{ $t("COMMON.SHOW_LESS") }}</span>
      <icon-base
        :icon="IconAdd"
        width="20"
        height="20"
        class="scale-75 transform"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import IconAdd from "@/components/icons/deals/IconAdd.vue";

defineProps<{ content: string }>();

const textContainerRef = ref<HTMLDivElement | null>(null);
const shouldShowLoadMoreButton = ref(true);
const shouldShowLoadLessButton = ref(false);

const isContentTooLong = computed(() => {
  const textContent = textContainerRef.value;
  const initialMaxBlockHeight = 110;

  return textContent && textContent.scrollHeight > initialMaxBlockHeight;
});

const isLoadMoreButtonVisible = computed(() => {
  return isContentTooLong.value && shouldShowLoadMoreButton.value;
});

const isShowLessButtonVisible = computed(() => {
  return isContentTooLong.value && shouldShowLoadLessButton.value;
});

const handleShouldShowLoadLessButtonClick = () => {
  shouldShowLoadMoreButton.value = true;
  shouldShowLoadLessButton.value = false;
};

const handleShouldLoadMoreButtonClick = () => {
  shouldShowLoadMoreButton.value = false;
  shouldShowLoadLessButton.value = true;
};
</script>
